module.exports = __webpack_public_path__ + "static/media/016.df41bdf9.jpg";